<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
  <vx-card>
    <vs-row class="mt-4">
      <vs-col class="w-1/6">
        <label class="vs-radio--label">No MR</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label">{{': '+patientMR}}</label>
      </vs-col>
      <vs-col class="w-1/6">
        <label class="vs-radio--label">Nama Pasien</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label">{{': '+patientName}}</label>
      </vs-col>
    </vs-row>
    <vs-row class="mt-8">
      <vs-col class="w-1/6">
        <label class="vs-radio--label">Tgl Lahir</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label">{{': '}}{{patientBirthdate | formatDate}}</label>
      </vs-col>
      <vs-col class="w-1/6">
        <label class="vs-radio--label">Umur</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label" v-if="patientAge!=''">{{': '+patientAge}}</label>
         <label class="vs-radio--label" v-else>{{': '}}{{patientBirthdate | formatAge}}</label>
      </vs-col>
    </vs-row>
    <vs-row class="mt-8">
      <vs-col class="w-1/6">
        <label class="vs-radio--label">Jns Kelamin</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label">{{': '+patientSex}}</label>
      </vs-col>
      <vs-col class="w-1/6">
        <label class="vs-radio--label">Lokasi</label>
      </vs-col>
      <vs-col class="w-1/4">
         <label class="vs-radio--label">{{': '+address}}</label>
      </vs-col>
      <vs-col class="w-1/6">
         <vs-button color="primary" type="filled" href="#" @click="downloadPdf">Print Hasil SWAB</vs-button>
      </vs-col>
    </vs-row>
     <vs-divider position="center">
      Timeline Pemeriksaan
     </vs-divider>
     <ul class="vx-timeline">
         <li v-for="item in data" :key="item.id">
          <div class="mt-10">
             <div v-if="item.swabResult!=null">
               <div class="timeline-icon" :class="`bg-${item.color}`">
                   <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
               </div>
               <div class="timeline-info">
                   <p class="font-semibold">Hasil Pemeriksaan SWAB :  <label :style="item.swabResult == 'Negative'?'color: green':'color: red'">{{item.swabResult}}</label></p>
               </div>
               <small class="font-semibold mt-4">{{ item.testDate | formatDate }}</small>
               <div class="timeline-info">
                   <p>Pemeriksaan SWAB Ke : {{item.num}}</p>
               </div>
               <div class="timeline-info">
                   <p>Lab Reference : {{item.labReferenceName}}</p>
               </div>
             </div>
             <div v-if="item.result&&item.result.result!=null">
               <div class="timeline-icon" :class="`bg-${item.color}`">
                   <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
               </div>
               <div class="timeline-info">
                   <p class="font-semibold">Hasil Pemeriksaan Laboratorium</p>
               </div>
               <small class="font-semibold">{{ item.testDate | formatDate }}</small>
               <div class="timeline-info">
                   <p>Lab Reference : {{item.labReferenceName}}</p>
               </div>
               <vs-table stripe :data="item.result.result" style="text-align:center;width:60%;">
                   <template slot="thead">
                       <vs-th>Nama Pemeriksaan</vs-th>
                       <vs-th>Hasil</vs-th>
                       <vs-th>Nilai Normal</vs-th>
                       <vs-th>&nbsp;</vs-th>
                   </template>
                   <template slot-scope="{data}">
                       <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                           <vs-td>
                               {{data[indextr].name}}
                           </vs-td>
                           <vs-td>
                               {{(data[indextr].result?data[indextr].result:'')}}
                           </vs-td>
                           <vs-td>
                               {{(data[indextr].range?data[indextr].range:'')}}
                           </vs-td>
                           <vs-td>
                             <vs-button class="mr-4" radius style="cursor: pointer;" @click="popupStatClick(data[indextr].result, data[indextr].name)" color="warning" icon="fast_forward"></vs-button>
                           </vs-td>
                       </vs-tr>
                   </template>
                </vs-table>
             </div>
           </div>
         </li>
     </ul>
  </vx-card>

  <vs-popup title="Statistik Hasil Laboratorium" :active.sync="popupStat">
  	<statistics-card-line :statistic="statisticRes" :statisticTitle="statisticTitleRes" :chartData="subscribersGainedChartData" type='area'/>
  </vs-popup>
  </div>
</template>

<script>
import axios from '@/axios.js';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import FeatherIcon from '@/components/FeatherIcon.vue';
import jsPDF from 'jspdf';
import moment from 'moment';
import imgData from '@/assets/images/logo/kop_cofid19.png';

export default {
  data() {
    return {
      data: [
        {
          title: 'test',
          desc: 'test',
          time: '1 May 2020',
          color: 'red lighten-2',
          icon: 'mdi-star',
        },
        {
          title: 'test1',
          desc: 'test',
          time: '1 May 2020',
          color: 'red lighten-2',
          icon: 'mdi-star',
        },
        {
          title: 'test2',
          desc: 'test',
          time: '1 May 2020',
          color: 'red lighten-2',
          icon: 'mdi-star',
        },
      ],
      id: this.$route.params.id,
      patientMR: '',
      patientName: '',
      patientBirthdate: '',
      patientAge: '',
      patientSex: '',
      address: '',
      popupStat: false,
      statisticTitleRes: '',
      statisticRes: '',
      subscribersGainedChartData: {
          series: [{
              name: 'Tanggal',
              data: [28, 40, 36, 52, 38, 60, 55]
          }],
          chartOptions: {
              grid: {
                  show: false,
                  padding: {
                      left: 0,
                      right: 0
                  }
              },
              chart: {
                  toolbar: {
                      show: false,
                  },
                  sparkline: {
                      enabled: true
                  }
              },
              dataLabels: {
                  enabled: false
              },
              stroke: {
                  curve: 'smooth',
                  width: 2.5
              },
              fill: {
                  type: 'gradient',
                  gradient: {
                      shadeIntensity: 0.9,
                      opacityFrom: 0.7,
                      opacityTo: 0.5,
                      stops: [0, 80, 100]
                  }
              },
              xaxis: {
                  type: 'numeric',
                  lines: {
                      show: false,
                  },
                  axisBorder: {
                      show: false,
                  },
                  labels: { show: false }
              },
              yaxis: [{
                  y: 0,
                  offsetX: 0,
                  offsetY: 0,
                  padding: { left: 0, right: 0 },
              }],
              tooltip: {
                  x: { show: false }
              },
          },
      },
    };
  },
  components: {
    FeatherIcon,
    StatisticsCardLine
  },
  methods: {
    popupStatClick(res, name) {
  console.log('res :'+res+'-'+name);
      this.statisticRes= res;
      this.statisticTitleRes= name;
      this.popupStat=true;
    },
    downloadPdf() {
      let pdfName = 'Hasil Swab Pasien : '+this.patientName+' (No MR : '+this.patientMR+')';
      let str = '<html><p><hr></p><p style="margin-left: 800px;">Jakarta, '+moment().format('DD-MMM-YYYY')+'<p><p><br></p>';
      str += '<p>Kepada<p>';
      str += '<p>Yth. Dokter DPJP RSDC Wisma Atlet<p>';
      str += '<p>Jakarta Pusat<p><p><br><br></p>';
      str += '<p>Kami ingin menginformasikan hasil pemeriksaan untuk kasus tersebut :<p>';
      str += '<p style="margin-left: 40px;">Nama : '+this.patientName+'<p>';
      str += '<p style="margin-left: 40px;">Nomor RM : '+this.patientMR+'<p>';
      str += '<p style="margin-left: 40px;">Tanggal Lahir : '+this.patientBirthdate+'<p>';
      str += '<p style="margin-left: 40px;">Ruang Perawatan : <p>';
      str += '<p style="margin-left: 40px;">Alamat : '+this.address+'<p><p><br><br></p>';

      this.data.forEach(function (x) {
        if (x.testType.id == 1) {
          str += '<p style="margin-left: 40px;text-color=red;">Hasil PCR SARS-CoV2 : '+x.swabResult+'<p>';
          str += '<p style="margin-left: 40px;">Tanggal Swab : '+moment(x.testDate).format('DD-MMM-YYYY')+'<p>';
          str += '<p style="margin-left: 40px;">LAB Rujukan : '+x.labReferenceName+'<p><br>';
        }

      });
      str += '<p><br><br></p>';
      str += '<p>Disclamer : <p>';
      str += '<p>Hasil PCR Negatif tidak selalu berarti pasien tidak terinfeksi oleh pathogen, namun hanya menunjukkan bahwa material genetic pathogen tidak ditemukan didalam sampel.<p></html>';

      var doc = new jsPDF();
      var img = new Image();
      img.src = imgData;
      doc.addImage(img, 'JPEG', 5, 10, 200, 25)
      doc.fromHTML(str, 30, 40, { width: 160 });
      doc.save(pdfName + '.pdf');
    }
  },
  created() {
    axios
        .get('/patient/get?id='+this.id)
        .then(response => {
            let x = response.data.data[0];

            this.patientMR = (x.patientNumber?x.patientNumber:'');
            this.patientName = (x.name?x.name:'');
            this.patientBirthdate = (x.dob?x.dob:'');
            this.patientAge = (x.patientAge?x.patientAge:'');
            this.patientSex = (x.genderName?x.genderName:'');
            this.address = (x.address?x.address:'');
            this.icon = 'mdi-star';
            this.color = 'red';

            this.data = x.result;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => this.loading = false);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
